__webpack_require__.p = "/phonetics/";